<template>
  <button
    :class="['x-button-container rounded-lg', getTwButtonClasses, twPadding, eventClass]"
    @click.stop="$emit('click')"
    :type="type"
  >
    <div
      v-if="loading"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <BcLottie
        :path="loadingLottiePath"
      />
    </div>
    <div :class="twIsVisible">
      <slot />  
    </div>
  </button>
</template>

<script setup lang="ts">

import { computed } from 'vue'

import { getGAEventName } from '../../utils/ga.util'
import { getTwBgWithHoverActiveClass, getTwHoverActiveClass } from '../../utils/tailwind.util'
import BcLottie from '../lottie/BcLottie.vue'
import { XButtonProps, XButtonTypes } from './button.types'

const props = withDefaults(defineProps<XButtonProps>(), {
  variant: XButtonTypes.SOLID,
  color: 'absoluteWhite',
  backgroundColor: 'theme',
  padding: 2,
})
defineEmits([ 'click' ])

const btnColor = computed(()=> {
  if (props.variant === XButtonTypes.SOLID) return props.color
  return props.color === 'absoluteWhite' ? 'dark' : props.color
})

const getTwButtonClasses = computed(()=>{
  const colorClass = `text-${btnColor.value}`
  const hoverClass = getTwHoverActiveClass(btnColor.value)

  switch (props.variant) {
    case XButtonTypes.SOLID:
      return [ getTwBgWithHoverActiveClass(props.backgroundColor), colorClass ]
    case XButtonTypes.LINE:
      return [ 'border', `border-${btnColor.value}/20`, hoverClass, colorClass ]
    case XButtonTypes.GLASS:
      return [ hoverClass, colorClass ]
    default:
      return []
  }
})

const twIsVisible = computed(()=>{
  return props.loading ? 'invisible' : 'visible'
})

const twPadding = computed(()=>{
  return `p-${props.padding}`
})

const eventClass = computed(()=>{
  return getGAEventName(props.gaEventName)
})

const loadingLottiePath = computed(()=>{
  const path = 'https://globalstatic.xangle.io/lottie'
  if (props.backgroundColor === 'white' || props.backgroundColor === 'absoluteWhite')
    return `${path}/processing_thema.json`
  return `${path}/processing_white.json`
})

</script>

<style scoped lang="scss">
</style>